document.addEventListener("DOMContentLoaded", () => {
  let search_button = document.querySelector(".sc_search_button");
  let searchTemplate = document.querySelector(".template-search");
  
  if (search_button && !searchTemplate) {
    let search_tag = search_button.dataset.searchtag;
    // Check if the href contains "/pages/womens"
    if (search_button.href.includes("/pages/womens")) {
        localStorage.setItem("productTag", "men");
    } else {
        localStorage.setItem("productTag", "women");
    }
    
    search_button.addEventListener("click", function (e) {
      let dataTag = e.target.dataset.searchtag;
      // console.log(dataTag);
      localStorage.setItem("productTag", dataTag);
    });
  }
    var checkTag = localStorage.getItem("productTag");
    let headerLogo = searchTemplate.querySelector(".header_logo a");
    if(searchTemplate && checkTag == "women" ){
        // searchTemplate.querySelector("header").style.background = "#92d0f2";
        headerLogo.setAttribute('href','/pages/womens');  
        search_button.setAttribute('href','/');  
        search_button.innerText = 'メンズはコチラ';  
    
        // Find the existing ol element
        var olElement = document.querySelector('.breadcrumb__wrap');
    
        // Find the first li element within the ol
        var firstLiLink = olElement.querySelector('li a');
        var firstLiSpan = olElement.querySelector('li span');
        firstLiLink.setAttribute('href', '/pages/womens');
        firstLiSpan.textContent = 'ウィメンズTOP';

    }
  
  let listItems = document.querySelectorAll(".list-view-item");
  let listItemWrap = document.querySelector(".list-view-items");
  let paginationWrap = document.querySelector('.magazine_pager');
  if (paginationWrap) {
    paginationWrap.classList.add("hide");
  }
  if (listItemWrap) {

    
    const wordsToCheck = ["男性", "男"];

    listItems.forEach((item, index) => {
      // Get the data-producttags attribute value
      let productTags = item?.querySelector(".list_view_inner_wrap")?.getAttribute("data-itemTags");
      let womenSearchtBtn = item?.querySelector(".button_blue_arrow01");
      if (productTags && productTags != null) {
        // console.log(productTags);
        let productArray = productTags.split(",");
        if (checkTag == "men") {
          if (productArray.includes("男性") || productArray.includes("m_magazine")) {
            item.style.display = "flex";
          } else {
            item.style.display = "none";
          }
        } else {
          womenSearchtBtn.style.background = "#92d0f2";
          if (productArray.includes("女性") || productArray.includes("w_magazine")) {
            item.style.display = "flex";
          } else {
            item.style.display = "none";
          }
        }
      } else {
        item.style.display = "none";
      }
    });
    let allHidden = Array.from(listItems).every(item => window.getComputedStyle(item).display === "none");
    if (listItems.length == 0 || allHidden) {
        document.querySelector('.ct_search_not_found').classList.remove("hide");
        // let paginationWrap = document.querySelector('.magazine_pager');
    }
    else{
      if (paginationWrap) {
        paginationWrap.classList.remove("hide");
      }
    }
  }
});
